<template>
  <div class="jzliu-bi-engine-chart-warp" :style="{ height: warpHeight }">
    <div ref="container"></div>
    <el-pagination style="margin-top: 8px;" v-if="chartData.queryList && chartData.styleConfig.commongConfig.pagination" :current-page="chartData.queryList.current" :page-size="chartData.queryList.pageSize"
      small @current-change="currentChange" layout="prev, pager, next" :total="chartData.queryList.total">
    </el-pagination>
  </div>
</template>

<script>
import { PivotSheet, S2Event ,TableSheet} from '@antv/s2';
import { debounce, difference } from 'lodash'
import { getCategoryDimension, initHeight, initWidth } from '../../utils/index'
import { log } from 'handlebars';
import { getSeriesFieldValues } from '../../utils/utils'
export default {
  name: "cTable",
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartConfigHandler: {
      type: Function,
      default: (conf) => conf,
    },
  },
  data() {
    return {
      prefix: '##jzliu##',
      s2: null,
      warpHeight: 200,
      warpWidth: 200,
      resizeObserver: null,
      curpPgination: this.chartData.styleConfig.commongConfig.pagination,
    }
  },
  mounted() {
    if (!this.chartData.queryList) {
      this.$set(this.chartData, 'queryList', {
        total: 0,
        current: 1,
        pageSize: 10,
      })
    } else {
      this.chartData.queryList.total = this.chartData.queryList.total || 0
      this.chartData.queryList.current = this.chartData.queryList.current || 1
      this.chartData.queryList.pageSize = this.chartData.queryList.pageSize || 10
    }
    this.$nextTick(() => {
      initHeight.call(this, 'warpHeight')
      initWidth.call(this, 'warpWidth')
      this.renderChart()
    })
  },
  watch: {
    'chartData.styleConfig.commongConfig.pagination': {
      handler(val) {
        if(this.curpPgination !== val) {
           this.$emit('table-page-change', val ? 1 : -1, val ? 10 : -1)
        }
        this.curpPgination = val
      },
      deep: true
    },
    'chartData.styleConfig': {
      handler() {
        this.debounceRenderChart()
      },
      deep: true
    },
    'chartData.styleConfig.helperData.fieldMap': {
      handler() {
        this.debounceRenderChart()
      },
      deep: true
    },
  },
  methods: {
    // 防抖渲染图表
    debounceRenderChart() {
      if (this.renderTimer) {
        clearTimeout(this.renderTimer)
      }
      this.renderTimer = setTimeout(() => {
        this.initTheme()
        this.s2 && this.s2.destroy()
        this.renderChart()
      }, 300)
    },
    currentChange(current) {
      this.chartData.queryList.current = current
      this.$emit('table-page-change', current, this.chartData.queryList.pageSize)
    },
    initTheme() {
      if (this.chartData.styleConfig) {
        this.s2.setTheme({ background: { color: this.chartData.styleConfig.commongConfig.customBackgroundColor ? this.chartData.styleConfig.commongConfig.backgroundColor : '#fff' } })
      }
    },
    getHeight(warpHeight) {
      let height = warpHeight - (this.chartData.styleConfig.commongConfig.pagination ? 30 : 0)
      if (this.chartData.styleConfig.commongConfig.showTitle) {
        height -= 20
      }
      return height
    },
    renderChart(update = true) {
      const sty = this.chartData.styleConfig.customStyle ?? {}
      const drillBreadcrumb = this.chartData.drillFields ? this.chartData.drillFields : []
      const drillBreadcrumbLength = drillBreadcrumb.length
      const drillField = this.chartData.fields.find(f => f.alias === 'drill') ?? []
      const drillFieldChooseFields = drillField.chooseFields ?? []
      const s2Options = {
        height: this.getHeight(this.warpHeight),
        width: this.warpWidth,
        ...sty,
        // 表格配置项
        interaction: {
          // 注册单元格事件
          // 注意：cellClick、cellHover等都可以用
          linkFields: drillBreadcrumbLength > 0 ? [drillFieldChooseFields[drillBreadcrumbLength - 1].unitCode] : drillFieldChooseFields.length > 0 ? [drillFieldChooseFields[0].unitCode] : [], // 告诉 S2 这一列是“可点链接”样式
        },
      };
      const mergeCells = this.chartData.styleConfig.commongConfig.mergeCells
      const categoryDimension = getCategoryDimension(this.chartData.fields)
      const originalRows = categoryDimension.rows || []
      const { values, columns } = categoryDimension
      const meta = JSON.parse(JSON.stringify(this.chartData.data.meta))
      const chartData = JSON.parse(JSON.stringify(this.chartData.data.data))
      console.log(chartData, "===chartData1111")
      // 当只有 values 时，确保 meta 中 values 字段的 name 正确设置
      // 使用 helperData.nameMap 获取正确的字段名称
      if (values.length > 0 && !originalRows.length && !columns.length) {
        const nameMap = this.chartData.styleConfig?.helperData?.nameMap || {}
        values.forEach(valueField => {
          const metaItem = meta.find(item => item.field === valueField)
          if (metaItem) {
            // 如果 meta 中没有 name 或 name 不正确，使用 nameMap 中的名称
            if (!metaItem.name || metaItem.name === valueField) {
              metaItem.name = nameMap[valueField] || metaItem.name || valueField
            }
          } else {
            // 如果 meta 中不存在该字段，添加它
            meta.push({
              field: valueField,
              name: nameMap[valueField] || valueField
            })
          }
        })
      }

      const rowKeyCountMap = {}
      const rowFieldMappings = originalRows.map((field) => {
        const count = (rowKeyCountMap[field] || 0) + 1
        rowKeyCountMap[field] = count
        const key = count === 1 ? field : `${field}__dup${count}`
        return {
          original: field,
          key,
          count,
        }
      })
      const rowKeys = rowFieldMappings.map(mapping => mapping.key)

      // 处理null值，将其转换为"-"
      const data = chartData.map(item => {
        const processedItem = { ...item }
        // 当数据没有包含所有行键时，填充缺失的键为空字符串，不然会导致图表后面的字段都渲染为空
        const noDataKeys = difference(rowKeys, Object.keys(item))
        if(noDataKeys.length > 0) {
          noDataKeys.forEach(key => {
            processedItem[key] = ''
          })
        }
        rowFieldMappings.forEach(({ key, original }) => {
          if (key !== original && Object.prototype.hasOwnProperty.call(processedItem, original)) {
            processedItem[key] = processedItem[original]
          }
        })
        Object.keys(processedItem).forEach(key => {
          if (processedItem[key] === null || processedItem[key] === undefined || processedItem[key] === '') {
            processedItem[key] = '-'
          }
        })
        processedItem.originalRow = { ...item }
        return processedItem
      })

      const rowName = rowFieldMappings[0]?.key
      if (rowFieldMappings.length > 0) {
        const metaMap = new Map(meta.map(item => [item.field, item]))
        rowFieldMappings.forEach(({ key, original, count }) => {
          if (count === 1) return
          const baseMeta = metaMap.get(original) || {}
          meta.push({
            ...baseMeta,
            field: key,
            name: baseMeta.name || original,
          })
        })
      }

      meta.forEach((element) => {
        if (element.field === rowName) {
          // 智能判断是否为日期格式，避免误处理日期数据
          element.formatter = !mergeCells ? (v) => {
            // 如果是其他格式且包含'-'，则分割取第一部分
            if (v.includes(this.prefix)) {
              return v.split(this.prefix)[0]
            }
            // 其他情况直接返回原值
            return v
          } : undefined
          data.forEach((item, index) => {
            // 同样需要判断是否为日期格式
            const value = item[rowName]
            if (!mergeCells) {
              // 如果是日期格式，不添加索引后缀
              if (/^\d{4}-\d{1,2}$/.test(value)) {
                item[rowName] = value
              } else {
                item[rowName] = `${value}${this.prefix}${index}`
              }
            } else {
              item[rowName] = value ?? '-'
            }
          })
        }
      });
      const isValueInCols = !rowKeys.length && !columns.length
      const confOpt = this.chartData.isCancel ? this.chartData.data : this.chartConfigHandler(this.chartData.data, this.chartData)
      const sortParams = []
      this.chartData.fields.forEach(field => {
       field.chooseFields.forEach(item => {
        if (item.customSortOrder) {
          sortParams.push({
            sortFieldId: item.unitCode,
            sortBy: item.customSortOrder,
          })
        }
       })
      })
      console.log('sortParams:', sortParams)
      this.s2 = !rowKeys.length && !columns.length ? new TableSheet(this.$refs.container, { ...confOpt, sortParams, data, meta, fields: { columns: values } }, s2Options) : new PivotSheet(this.$refs.container, { ...confOpt, sortParams, data, meta, fields: { rows: rowKeys, values, columns } }, s2Options);
      const debounceRender = debounce((width, height) => {
        this.s2.changeSheetSize(width, this.getHeight(height))
        this.initTheme()
        this.s2.render(false)
      }, 200)
      this.resizeObserver = new ResizeObserver(([entry] = []) => {
        const [size] = entry.borderBoxSize || [];
        debounceRender(size.inlineSize, size.blockSize)
      });
      this.resizeObserver.observe(this.$el);
      // this.initTheme()
      const cellTheme = {
        cell: {
          backgroundColorOpacity: 0,
          verticalBorderColorOpacity: 0.5,
          horizontalBorderColorOpacity: 0.5,
        },
      };
      if(isValueInCols) {
        cellTheme.text = {
          textAlign: 'left',
        }
        cellTheme.bolderText = {
          textAlign: 'left',
        }
      }
      const s2Theme = {
        background: {
          opacity: 0,
        },
        cornerCell: cellTheme,
        rowCell: cellTheme,
        colCell: cellTheme,
        dataCell: cellTheme,
        cornerCell: cellTheme,
        splitLine: cellTheme,
      };
      this.s2.setTheme(s2Theme);
      this.s2.render(update);
      this.s2.on(S2Event.ROW_CELL_CLICK, (event) => {
        // 首先拿到单元格当前信息
        const cell = this.s2.getCell(event.target)
        const meta = cell.getMeta()
        // 获取当前行数据
        const rowData = this.s2.dataSet.getMultiData(meta.query)
        const tempData = rowData[0] ?? {}
        this.$emit('drill-item-click', { ...tempData.originalRow })
      })
    }
  },
  destroyed() {
    this.$el && this.resizeObserver.observe(this.$el);
  }
}
</script>

<style scoped lang="less">
.jzliu-bi-engine-chart-warp {
  /deep/ .el-pagination {
    .el-pager li {
      background-color: transparent;
      margin: 0 2px;

      &:hover {
        background-color: transparent;
        border-color: transparent;
      }

      &.active {
        background-color: transparent;
        border-color: transparent;

        &:hover {
          background-color: transparent;
          border-color: transparent;
        }
      }
    }

    .btn-prev,
    .btn-next {
      background-color: transparent;
      border: 1px solid transparent;
      margin: 0 2px;

      &:hover {
        background-color: transparent;
        border-color: transparent;
      }

      &:disabled {
        background-color: transparent;
        border-color: transparent;
        cursor: not-allowed;
      }
    }
  }
}
</style>
